export default {
      id: "ic_second_user-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_second_user-usage",
      toString: function () {
        return this.url;
      }
    }